<template>
  <div>
    <WsText001 h6 class="mt-8">
      32-1. LlSystemClassItemList with cards
    </WsText001>
    <LlSystemClassItemList
      :system-classes="systemClassList"
    >
      <template>
        <LvCard
          v-for="(checklist, checklistIndex) in 
          cardData"
          :key="checklistIndex"
          :title="checklist.title"
          :tags="checklist.tags"
          :spec="checklist.spec"
          :chips="checklist.chips"
          :hasTopBar="true"
        />
      </template>
    </LlSystemClassItemList>
    <WsText001 h6 class="mt-16">
      32-2. LlSystemClassItemList with no auth
    </WsText001>
    <LlSystemClassItemList
      :system-classes="systemClassList"
    >
      <template #default>
        <div
          class="ml-40"
        >
          {{ $t("您無此領域權限") }}
        </div>
      </template>
    </LlSystemClassItemList>
    <WsText001 h6 class="mt-16">
      32-3. LlSystemClassItemList with no cards
    </WsText001>
    <LlSystemClassItemList
      :system-classes="systemClassList"
    >
      <template #default>
        <div
          class="ml-40"
        >
          {{ $t("目前尚無資料") }}
        </div>
      </template>
    </LlSystemClassItemList>
    <WsText001 h6 class="mt-16">
      32-1. LlSystemClassItemList with cards fit filter
    </WsText001>
    <LlSystemClassItemList
      :system-classes="systemClassList"
    >
      <template #default>
        <div
          class="ml-40"
        >
          {{ $t("找不到符合篩選條件的結果") }}
        </div>
      </template>
    </LlSystemClassItemList>
  </div>
</template>

<script>
export default {
  data() {
    return {
      systemClassList: [
        {
          id: 4,
          name: "環保",
          system_subclasses: [
            {
              id: 14,
              name: "空氣污染防制",
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/15970290907Hxye/%E7%A9%BA%E6%B0%A3%E6%B1%A1%E6%9F%93%E9%98%B2%E6%B2%BB.png?signature=75c41b3967b7c580f710e6aa05a1b868d08521cd7495273a9b12736d91d7700d",
            },
            {
              id: 15,
              name: "水污染防治",
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/15970291166yRtf/%E6%B0%B4%E6%B1%A1%E6%9F%93%E9%98%B2%E6%B2%BB.png?signature=7528b177496042d3318344d1aa5e5f0718a4001d945a0c2a8a35de2e8258e0b9",
            },
          ],
        },
      ],
      cardData: [
        {
          id: 583,
          title: "固定污染源自行檢查表-KUI建-KUI填-WJP覆 (6/30-7/15測試)",
          tags: [
            {
              text: "空氣污染防制",
              image:
                "https://api.ll-esh-app.wasateam.com/api/system_class/icon/15970290907Hxye/%E7%A9%BA%E6%B0%A3%E6%B1%A1%E6%9F%93%E9%98%B2%E6%B2%BB.png?signature=75c41b3967b7c580f710e6aa05a1b868d08521cd7495273a9b12736d91d7700d",
            },
          ],
          spec: [
            {
              title: "答題者",
              text: "陳奎霖[LAW]",
            },
            {
              title: "覆核者",
              text: "王逸凡[IT]",
            },
            {
              title: "管理者",
              text: "陳姿臻[KM]",
            },
            {
              title: "頻率",
              text: "day",
            },
          ],
          chips: [
            {
              color: "yellow",
              text: "版本更新",
            },
          ],
        },
        {
          id: 583,
          title: "固定污染源自行檢查表-KUI建-KUI填-WJP覆 (6/30-7/15測試)",
          tags: [
            {
              text: "空氣污染防制",
              image:
                "https://api.ll-esh-app.wasateam.com/api/system_class/icon/15970290907Hxye/%E7%A9%BA%E6%B0%A3%E6%B1%A1%E6%9F%93%E9%98%B2%E6%B2%BB.png?signature=75c41b3967b7c580f710e6aa05a1b868d08521cd7495273a9b12736d91d7700d",
            },
          ],
          spec: [
            {
              title: "答題者",
              text: "陳奎霖[LAW]",
            },
            {
              title: "覆核者",
              text: "王逸凡[IT]",
            },
            {
              title: "管理者",
              text: "陳姿臻[KM]",
            },
            {
              title: "頻率",
              text: "day",
            },
          ],
          chips: [
            {
              color: "yellow",
              text: "版本更新",
            },
          ],
        },
      ],
    }
  }
}
</script>